module.exports = __webpack_public_path__ + "img/image40.915f0d1a.webp";